import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import {
    ActivityLogController_getActivityLog,
    PenOverviewController_getPenOverview,
    TasksController_getTasks,
} from '@/services/services';

/**
 * Marks the tasks, the activity log and the pen overview stale, every location's, so the
 * dashboard refetches all three after a task or activity change.
 */
export function useRefreshOperationalDashboard(): () => void {
    const queryClient = useQueryClient();
    return useCallback(() => {
        queryClient.invalidateQueries({ queryKey: [TasksController_getTasks.key] });
        queryClient.invalidateQueries({ queryKey: [ActivityLogController_getActivityLog.key] });
        queryClient.invalidateQueries({ queryKey: [PenOverviewController_getPenOverview.key] });
    }, [queryClient]);
}
